/*
 * @Author: Teemo Ding
 * @Date: 2022-02-28 15:48:53
 * @LastEditTime: 2022-02-28 15:48:54
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/invoice.ts
 */

export enum InvoiceType {
  Individual = 'Individual',
  Company = 'Company',
}
